import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Loader } from "@mantine/core";
import { useGetMerchantFeatureFlags } from "../hooks/queries/useMerchantQueries";

function FeatureFlagRoute({ flag, children }) {
  const { data: featureFlags, isLoading } = useGetMerchantFeatureFlags();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader color="blue" />
      </div>
    );
  }

  if (!featureFlags?.[flag]) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

FeatureFlagRoute.propTypes = {
  flag: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default FeatureFlagRoute;
